import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'
import {getLoginId} from '../../functions/Common.js'


// 保存粉丝的消费信息
export function webSave(param,callback){
	param.managerId = getLoginId()
	request({
			method: 'post',
			url: 'Emoji/save',
			data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 根据粉丝id，获取粉丝详细数据-单表数据
export function webGetList(callback){
	request({
			method: 'post',
			url: 'Emoji/getList'
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}